/**
 * OnlyOffice Feature Routes
 */

import type { RouteRecordRaw } from 'vue-router';

export const onlyofficeRoutes: RouteRecordRaw[] = [
  {
    path: '/documents',
    name: 'Documents',
    component: () => import('./views/DocumentEditorPage.vue'),
    meta: {
      title: 'onlyoffice.Document Editor',
      requiresAuth: false,
      layout: 'default',
    },
  },
  {
    path: '/t-doc',
    name: 'TDoc',
    component: () => import('./views/TemplateView.vue'),
    meta: {
      title: 'onlyoffice.Doc Management',
      requiresAuth: false,
      layout: 'default',
    },
  },
  {
    path: '/onlyoffice/templates',
    name: 'TemplateList',
    component: () => import('./views/TemplateView.vue'),
    meta: {
      title: 'onlyoffice.Templates',
      requiresAuth: false,
      layout: 'default',
    },
  },
  {
    path: '/onlyoffice/template/edit/:id',
    name: 'TemplateEdit',
    component: () => import('./views/TemplateEditorPage.vue'),
    meta: {
      title: 'onlyoffice.Edit Template',
      requiresAuth: false,
      layout: 'default',
    },
  },
  {
    path: '/onlyoffice/template/preview/:id',
    name: 'TemplatePreview',
    component: () => import('./views/TemplateEditorPage.vue'),
    meta: {
      title: 'onlyoffice.Preview Template',
      requiresAuth: false,
      layout: 'default',
    },
  },
  {
    path: '/onlyoffice/template/create',
    name: 'TemplateCreate',
    component: () => import('./views/TemplateUploadPage.vue'),
    meta: {
      title: 'onlyoffice.Create New Template',
      requiresAuth: false,
      layout: 'default',
    },
  },
  {
    path: '/onlyoffice/templates/adm',
    name: 'TemplateAdm',
    component: () => import('./views/TemplateAdm.vue'),
    meta: {
      title: 'onlyoffice.Lettaga Template Administration',
      requiresAuth: false,
      layout: 'default',
    },
  },
  {
    path: '/onlyoffice/templates/variables',
    name: 'TemplateVariableAdm',
    component: () => import('./views/TemplateVariableAdm.vue'),
    meta: {
      title: 'onlyoffice.Template Variable Administration',
      requiresAuth: true,
      layout: 'default',
    },
  },
];

// Default export도 제공 (자동 로딩을 위해)
export default onlyofficeRoutes;
